import { get_csrf }  from '../csrf.js';
import { loadStyleSheetsApplyingToElement } from '../styles/utils.js';

// TODO: move this out of ckeditor folder
var editor_styles = ["/vendor/ckeditor/plugins/kmsgallery/styles/gallery.css", 
                     "/static/build/css/kms_css.css" ];

export class RichEditor {
	constructor(el){
		this.element = el;
        this.editorReady = false;
        this.loadTasks = [];

        //Old presets...
        if (el.classList.contains('rich-text-full-uploads')) {
            this._mode='full';
            this._secure_uploads = true;
        } else if (el.classList.contains('rich-text-full')) {
            this._mode='full';
            this._secure_uploads = false;
        } else if (el.classList.contains('rich-text-basic')) {
            this._mode='form';
            this._secure_uploads = false;
        } else { //new flexible modes
            this._mode = this.element.dataset.editorMode || 'full'; // TODO: is this a reasonable default?
            this._uploads = this.element.hasAttribute('data-editor-uploads');
        }
        this._secure_uploads = this.element.hasAttribute('data-editor-secure-uploads');        
        get_csrf().then((csrf_token) => {
            this.csrf_token = csrf_token;
            this.initialise();
        });
	}
    initialise() {
        //csrf_token now available. 
        this.loadTasks.forEach(task=>task());
    }
    get uploads() {
        return this._uploads;
    }
    get secure_uploads() {
        return this._secure_uploads;
    }
    set secure_uploads(value) {
        this._secure_uploads = value;
    }
    get mode() {
        return this._mode;
    }
    getData(){	// Returns a promise that resolves to the editor source data
        return this.element.value;
    }
    getHTML(){	// Returns a promise that resolves to the editor HTML (if available)
        return this.element.value;
    }
    setContent(raw_src, ready_callback){
        if (this.editorReady) {
            this.element.style.display='none';
            this.setEditorContent(raw_src, ready_callback);
        } else {
            this.loadTasks.push(() =>{
                this.element.style.display='none';
                this.setEditorContent(raw_src, ready_callback);   
            });
        }
    }
    setEditorContent(/*raw_src, ready_callback*/){
        throw new Error('Child class must implement the method setEditorContent!');
    }
    destroy(){		
        this.element.style.display = null;
        this.removeEditor();		
    }
    removeEditor(){
        throw new Error('Child class must implement the method removeEditor!');
    }
}

export class ConsoleEditor {
    // This class shows the editor immediately, and updates the form element 
    // when the form is submitted.
    constructor(el, editorType){
        this.element = el;
        this.element.style.display = 'none';
        this.editorType = editorType;
        this.is_inline = false;
        this.initialise();
    }
    
    getStyleSheetUrls(){
        var urls = editor_styles;
        if (this.element.dataset.editorStylesUrl)
            urls.push(this.element.dataset.editorStylesUrl);
        else 
            urls.push('/app/css/editor.css');
        return urls;
    }
    initialise() {
        this.createWrapper();
        // Load the editor styles such that they only apply inside the wrapper
        loadStyleSheetsApplyingToElement(this.wrap.id, this.getStyleSheetUrls(), this.createEditor.bind(this));
    }
    createEditor(){
        this.editor = new this.editorType(this.element, this);
        this.editor.setContent(this.element.value, () => {this.loader.remove();});
        // Set up form submit handler to update the form element
        this.element.form.addEventListener('submit', () => {
            this.element.value = this.editor.getData();
        });        
    }
    createWrapper(){
        if (this.wrap) return;		
        this.wrap = document.createElement('div');
        this.wrap.classList.add('console-edit-wrap');
        // Give the wrapper a unique id
        this.wrap.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
        this.element.parentNode.insertBefore(this.wrap, this.element)
        this.wrap.appendChild(this.element);
        this.editor_el = document.createElement('div');
        this.wrap.appendChild(this.editor_el);
        this.loader = document.createElement('div');
        this.loader.classList.add('light-bg-loader');
        this.wrap.appendChild(this.loader);
    }
}
export class InlineEditor {
    // This class shows the editor only when edit mode is selected.
    constructor(el, editorType, content_processor){
        this.element = el;
        this.editorType = editorType;
        this.editing = false;
        this.is_inline = true;
        this.content_processor = content_processor;
        this.initialise();
    }
    getStyleSheetUrls(){
        return editor_styles;
    }

    initialise(){
        this.wrapperHoverOn = this.wrapperHoverOn.bind(this);
        this.wrapperHoverOff = this.wrapperHoverOff.bind(this);
        this.edit = this.edit.bind(this);
        this.save = this.save.bind(this);
        this.cancel = this.cancel.bind(this);
        this.closeEdit = this.closeEdit.bind(this);
        this.createWrapper();
        loadStyleSheetsApplyingToElement(this.wrap.id, this.getStyleSheetUrls());
    }

    wrapperHoverOn(){
        if (!this.editing) {
            this.wrap.style.boxShadow ='0px 0px 10px 0px #000000';
            this.editControls.style.opacity = 1;
        }
    }

    wrapperHoverOff(){		
        if (!this.editing) {
            this.wrap.style.boxShadow ='none';
            this.editControls.style.opacity = 0;
        }
    }

    createWrapper(){
        if (this.wrap) return;		
        this.wrap = document.createElement('div');
        // Give the wrapper a unique id
        this.wrap.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
        this.wrap.classList.add('inline-edit-wrap');
        this.element.parentNode.insertBefore(this.wrap, this.element)
        this.wrap.appendChild(this.element);
        this.wrap.insertAdjacentHTML('beforeend',
            `<div class='inline-edit-controls'><span class="edit"><img alt="editor edit icon" src="/static/frontend/img/edit.svg"/></span><span class="save" style="display:none">Save</span> <span class="cancel" style="display:none">Cancel</span></div>`
        )
        this.editControls=this.wrap.querySelector(".inline-edit-controls");
        this.wrap.querySelector(".inline-edit-controls .edit").addEventListener('click', this.edit);
        this.wrap.querySelector(".inline-edit-controls .save").addEventListener('click', this.save);
        this.wrap.querySelector(".inline-edit-controls .cancel").addEventListener('click', this.cancel);
        this.wrap.addEventListener('mouseenter', this.wrapperHoverOn);
        this.wrap.addEventListener('mouseleave', this.wrapperHoverOff);
    }

    displayEditUI(){
        this.wrap.style.boxShadow ='0px 0px 10px 0px #000000';
        this.editControls.style.opacity=1;
        this.editControls.querySelector('.edit').style.display='none';
        this.editControls.querySelector('.save').style.display='inline';
        this.editControls.querySelector('.cancel').style.display='inline';
    }

    hideEditUI(){
        this.wrap.style.boxShadow = 'none';
        this.editControls.style.opacity = 0;
        this.element.contentEditable = 'false';		
        this.editControls.querySelector('.edit').style.display='inline';
        this.editControls.querySelector('.save').style.display='none';
        this.editControls.querySelector('.cancel').style.display='none';
    }

    cancel() {
        this.closeEdit();
        // Alternatively we can get the content back from the server.
        this.element.innerHTML = this.element.origHTML;
        this.content_processor(this.element);
    }

    closeEdit (){
        // Get browserified (processed) content
        if (this.wrap.querySelector('.inline-edit-save'))
            this.wrap.querySelector('.inline-edit-save').remove();
        this.editor.destroy();
        this.hideEditUI();
        this.wrap.style.boxShadow ='0px 0px 10px 0px #00cc00';
        setTimeout(() => {
            this.wrap.style.boxShadow = 'none';
        }, 1000);
        this.editing = false;
    }

    get content_url(){
        return `/console/content/${this.element.dataset.content_type}/update/${this.element.dataset.id}`;
    }

    edit(){
        this.editing = true;
        this.element.origHTML = this.element.innerHTML;
        this.displayEditUI();
        
        fetch(this.content_url,
        {
            method:'get',
            headers: {
                'Accept': 'application/json'
                },
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error('Something went wrong');
            }
        }).then((responseJson) => {
            let body = responseJson.content_version.content;
            let raw_src = responseJson.content_version.content_src || body;
            // This is the point where the editor class will load
            this.edit_content_loaded(body, raw_src);
        })
        .catch(function(err) {
            console.log(err);
            alert('error loading content, please try again');
        });
    }
    save(){
        // Get the editor content, and save it to the server
        //Might need to switch on element.data('type').
        let formData = new FormData();
        formData.append('content_src', this.editor.getData());
        formData.append('content', this.editor.getHTML());
        formData.append('editor', this.element.dataset.editor);
        fetch(this.content_url,
        {
            method:'post',
            body: formData,
            headers: {
                'Accept': 'application/json',
                'X-CSRF': this.editor.csrf_token
              },
        }).then((response) => {
            if (response.ok) {
                return response.json();
              } else {
                throw new Error('Something went wrong');
              }
        }).then((responseJson) => {
            this.closeEdit();
            this.element.innerHTML = responseJson.processed_content;
            this.element.origsrc = responseJson.content;
            this.content_processor(this.element);
        })
        .catch(function(err) {
            console.log(err);
            alert('error saving content, please try again');
        });
    }
    edit_content_loaded(body, raw_src) {
        // Calls the external editor
        this.editor = new this.editorType(this.element, this);

        // Update the UI of the element to be modified to contain the editor
        // this will call setEditorContent from the external editor (e.g edit-tinymce)
        this.editor.setContent(raw_src);
        console.debug(body, raw_src);
    }
}
